import type { ContainerModule } from '@yandex-int/k-common';
import { BackgroundImage, Text } from 'platform-components';
import React, { useMemo } from 'react';

import { getSlugGroupNameWithOrder } from 'utils/get-slug-group-name-with-order';

import { CourseContainerModuleLinkList } from '../__module-link-list/course-container__module-link-list';

import './course-container__paragraph.scss';

interface Props {
    groupName: string;
    modules: Array<ContainerModule>;
    order: number;
    titlesOnly?: boolean;
}

export const CourseContainerParagraph = ({ groupName, modules, order, titlesOnly }: Props) => {
    const module = useMemo(
        () => modules.find((cm) => cm.module.color || cm.module.cover || cm.module.cover_background_color),
        [modules]
    );

    let hatStyle;
    let coverSrc;
    let coverStyle;

    if (module) {
        const {
            module: { cover_background_color: moduleCoverColor, cover: moduleCover, color: moduleColor },
        } = module;

        coverSrc = moduleCover || undefined;

        hatStyle = {
            backgroundColor: moduleColor || undefined,
        };

        coverStyle = {
            backgroundColor: moduleCoverColor || undefined,
        };
    }

    return (
        <div className="course-container__paragraph" key={`${groupName}-paragraph`}>
            <div className="course-container__paragraph-hat" style={hatStyle} />
            <div className="course-container__paragraph-content">
                <div className="course-container__paragraph-header">
                    <Text size={Text.SIZE.XXL} weight={Text.WEIGHT.M}>
                        {getSlugGroupNameWithOrder(groupName, order)}
                    </Text>
                </div>
                <CourseContainerModuleLinkList key={groupName} modules={modules} titlesOnly={titlesOnly} />
            </div>
            {module && (
                <div className="course-container__paragraph-cover-wrapper">
                    <div className="course-container__paragraph-background-hat" style={coverStyle} />
                    <BackgroundImage
                        mix="course-container__paragraph-cover"
                        objectFit="cover"
                        objectPosition="right center"
                        src={coverSrc}
                    />
                </div>
            )}
        </div>
    );
};
